import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { markBasicCheckoutReturn } from '../utils/checkoutReturn';
import { CheckCircle2, AlertTriangle, Plus, Minus } from 'lucide-react';
export const ProductTomos = () => {
  const [openTomo, setOpenTomo] = useState<number | null>(null);
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1 — El Arsenal Sin Materiales',
    desc: 'Juegos y actividades sin necesitar nada del depósito. Para cuando llegás al patio con las manos vacías.',
    color: 'bg-blue-600',
    accent: 'from-blue-500 to-blue-400',
    label: 'Sin Materiales',
    activities: '20+ Actividades'
  }, {
    icon: '📗',
    title: 'Tomo 2 — Entrada en Calor Dinámica',
    desc: '+20 activaciones de 10 minutos listas para usar. Para que el grupo arranque con energía desde el minuto 1.',
    color: 'bg-green-600',
    accent: 'from-green-500 to-emerald-400',
    label: 'Entrada en Calor',
    activities: '20+ Activaciones'
  }, {
    icon: '📙',
    title: 'Tomo 3 — Juegos en Equipo',
    desc: '+20 dinámicas de cooperación y competencia. Para que el grupo trabaje junto sin que vos tengas que mediar todo.',
    color: 'bg-orange-500',
    accent: 'from-orange-500 to-amber-400',
    label: 'Juegos en Equipo',
    activities: '20+ Dinámicas'
  }, {
    icon: '📕',
    title: 'Tomo 4 — Coordinación y Motricidad',
    desc: '+20 sesiones de equilibrio, agilidad y control corporal. Para desarrollar habilidades motrices reales con juegos que enganchan.',
    color: 'bg-red-600',
    accent: 'from-red-500 to-rose-400',
    label: 'Coordinación',
    activities: '20+ Sesiones'
  }, {
    icon: '📓',
    title: 'Tomo 5 — Resistencia y Actividad Física',
    desc: '+20 juegos de alta intensidad listos para usar. Para las clases donde el grupo necesita moverse de verdad.',
    color: 'bg-purple-600',
    accent: 'from-purple-500 to-fuchsia-400',
    label: 'Resistencia',
    activities: '20+ Juegos'
  }, {
    icon: '📔',
    title: 'Tomo 6 — Clases Completas Listas',
    desc: '+20 clases de 40 minutos con inicio, desarrollo y cierre. Para el domingo a la noche cuando necesitás todo resuelto.',
    color: 'bg-yellow-600',
    accent: 'from-yellow-500 to-amber-400',
    label: 'Clases Listas',
    activities: '20+ Clases'
  }];
  const features = ['Objetivo de la clase claro y visible', 'Materiales con íconos visuales (o sin materiales)', 'Entrada en calor lista para dictar', 'Parte principal con consignas palabra por palabra', 'Progresión de dificultad y variantes A/B/C', 'Cierre y vuelta a la calma específicos', 'Tip del Profe al final de cada hoja', 'Una clase por página — sin hojas complicadas'];
  const featureChips = ['✅ Primaria + Secundaria', '✅ Planificación anual lista', '✅ Consignas palabra por palabra', '✅ Adaptaciones para lluvia y espacios chicos', '✅ Sin materiales obligatorios', '✅ 120+ actividades listas para usar'];
  return <Section className="bg-[#050d1a]" data-id="element-19" data-mp="qpn5jb151z7e">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-20" data-mp="lnfo45xjhqxo">
        <div className="inline-flex items-center gap-1.5 bg-yellow-400/15 border border-yellow-400/40 text-yellow-300 font-bold px-3 py-1 rounded-full mb-3 md:mb-4 text-[11px] md:text-sm" data-id="element-21" data-mp="lqa9q0sahhso">
          <span data-id="element-22" data-mp="1eezbm2165r5h">🏆</span>
          <span className="uppercase tracking-wide" data-id="element-23" data-mp="19ds13v7n6dv4">
            Sistema n°1 para profes de Ed. Física
          </span>
        </div>
        <h2 className="md:text-5xl font-bold text-white text-[34px] mt-[-5px] mb-[16px]" data-id="element-24" data-mp="14m0ajkohk84z">
          🏆 EL ARSENAL DEL PROFE™
        </h2>
        <p className="text-base md:text-xl text-gray-300 font-medium px-2" data-id="element-25" data-mp="10l838wz6cdbc">
          6 Tomos + 6 Bonos — Primaria + Secundaria
          <br data-id="element-26" data-mp="1scnu537rkm7d" />
          120+ Actividades — Todo resuelto.
        </p>
      </FadeIn>

      <FadeIn delay={0.2} className="mb-6" data-id="element-27" data-mp="1sat9lq0emw3t">
        <div className="flex justify-center gap-3 md:gap-5 px-2 md:px-0" data-id="element-28" data-mp="1ctl833koo1t8">
          {tomos.map((tomo, i) => <div key={i} className={`${tomo.color} w-[52px] md:w-36 h-[80px] md:h-52 rounded-lg md:rounded-xl shadow-lg flex flex-col items-center justify-end p-1.5 md:p-4 text-center text-white relative overflow-hidden transform hover:-translate-y-2 transition-transform border border-white/20`} data-id="element-29" data-mp="1huiopbq1onsm" data-mpi={i}>
              <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent h-1/3" data-id="element-30" data-mp="1vngrvk8qbk6q"></div>
              <span className="font-bold text-white text-[10px] md:text-base leading-tight drop-shadow-md" data-id="element-31" data-mp="1mssjvmbrroe8">
                TOMO {i + 1}
              </span>
            </div>)}
        </div>
        <div className="text-center mt-4" data-id="element-32" data-mp="2ek062nye3ya5">
          <span className="inline-block bg-brandOrange text-white text-xs md:text-sm font-bold px-4 py-1.5 rounded-full" data-id="element-33" data-mp="2ej6th6cr2ek3">
            6 TOMOS COMPLETOS
          </span>
        </div>
      </FadeIn>

      <FadeIn delay={0.3} className="mb-5 md:mb-6" data-id="element-34" data-mp="7uofc66kopmj">
        <div className="flex flex-wrap justify-center gap-2 md:gap-3 max-w-3xl mx-auto" data-id="element-35" data-mp="2wmupgti0i8y">
          {featureChips.map((chip, i) => <span key={i} className="bg-brandOrange/10 text-brandOrange border border-brandOrange/20 shadow-sm px-3 py-1.5 rounded-full md:text-sm font-medium text-[10px] pt-[3px] pb-[3px] pl-[10px] pr-[10px]" data-id="element-36" data-mp="hlstx4sc68gu" data-mpi={i}>
              {chip}
            </span>)}
        </div>
      </FadeIn>

      <FadeIn className="text-center mb-5 md:mb-6" data-id="element-37" data-mp="3g4znmpas6it8">
        <span className="inline-block bg-brandOrange text-white text-sm md:text-base font-bold px-5 py-2 md:px-6 md:py-2.5 rounded-full" data-id="element-38" data-mp="3v0yujwm5mcws">
          📦 Lo que recibís
        </span>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6 mb-10 md:mb-16" data-id="element-39" data-mp="1a9owgq4l6ulj">
        {tomos.map((tomo, i) => {
        const isOpen = openTomo === i;
        return <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-40" data-mp="1cetkhxsvdp34" data-mpi={i}>
              <button type="button" onClick={() => setOpenTomo(isOpen ? null : i)} className={`w-full text-left bg-[#070f1e] rounded-2xl border h-full transition-all overflow-hidden relative ${isOpen ? 'border-brandOrange shadow-xl shadow-brandOrange/10' : 'border-white/10 hover:border-white/20'}`} aria-expanded={isOpen} data-id="element-41" data-mp="1cgef1nf6p80z">
                {/* Top accent gradient line */}
                <div className={`h-[3px] w-full bg-gradient-to-r ${tomo.accent}`} data-id="element-42" data-mp="ym3vrllyi62b"></div>

                <div className="p-4 md:p-5" data-id="element-43" data-mp="13kf9w8jab2qc">
                  <div className="flex items-start justify-between gap-3" data-id="element-44" data-mp="18cggpexoo18z">
                    <div className="flex items-start gap-3 min-w-0 flex-1" data-id="element-45" data-mp="18et4w9u1b7uh">
                      <div className="text-3xl md:text-4xl shrink-0 leading-none" data-id="element-46" data-mp="awt3ksio9jzs">
                        {tomo.icon}
                      </div>
                      <div className="min-w-0 flex-1" data-id="element-47" data-mp="2t6f8ki96j41c">
                        <h3 className="text-base md:text-lg font-bold text-white leading-tight mb-2" data-id="element-48" data-mp="2t5w3w38jic59">
                          {tomo.title}
                        </h3>
                        <div className="flex flex-wrap items-center gap-1.5" data-id="element-49" data-mp="2k4xxxfejjuk1">
                          <span className="inline-block bg-brandOrange/15 text-brandOrange border border-brandOrange/30 text-[10px] md:text-xs font-bold uppercase tracking-wide px-2 py-0.5 rounded-md" data-id="element-50" data-mp="2f7fkpcthqt68">
                            {tomo.activities}
                          </span>
                          <span className="inline-block bg-white/5 text-gray-400 border border-white/10 text-[10px] md:text-xs font-bold uppercase tracking-wide px-2 py-0.5 rounded-md" data-id="element-51" data-mp="21fiyfpei7dhr">
                            {tomo.label}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-all ${isOpen ? 'bg-brandOrange text-white' : 'bg-white/10 text-white hover:bg-white/20'}`} data-id="element-52" data-mp="1mja0qsa9h87g">
                      {isOpen ? <Minus size={16} data-id="element-53" data-mp="31e8kjxh5eb2w" /> : <Plus size={16} data-id="element-54" data-mp="31ertiootlp4s" />}
                    </div>
                  </div>
                  <div className={`grid transition-all duration-300 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100 mt-3' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-55" data-mp="36d33czf47zn0">
                    <div className="overflow-hidden" data-id="element-56" data-mp="2wex3encvd3ks">
                      <p className="text-gray-300 text-sm md:text-base leading-snug" data-id="element-57" data-mp="2wggiwbqpbali">
                        {tomo.desc}
                      </p>
                    </div>
                  </div>
                </div>
              </button>
            </FadeIn>;
      })}
      </div>

      <FadeIn delay={0.4} data-id="element-58" data-mp="28q4f9d2ho00q">
        <div className="bg-[#0c1626] rounded-2xl md:rounded-3xl p-5 md:p-12 border border-white/10 shadow-sm max-w-4xl mx-auto" data-id="element-59" data-mp="28rxa7v3qovsw">
          <h3 className="text-xl md:text-2xl font-bold text-white mb-4 md:mb-8 text-center" data-id="element-60" data-mp="1u2cdy89dlzzn">
            Cada clase incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-2.5 md:gap-4" data-id="element-61" data-mp="1q2v7pcm4kytf">
            {features.map((feature, i) => <div key={i} className="flex items-start gap-2 md:gap-3" data-id="element-62" data-mp="23yp9zcse8pxk" data-mpi={i}>
                <CheckCircle2 className="text-green-400 shrink-0 mt-0.5 md:mt-1 w-4 h-4 md:w-5 md:h-5" data-id="element-63" data-mp="1z0nnsizo8ahv" />
                <span className="text-gray-300 font-medium text-[13px] md:text-base leading-snug" data-id="element-64" data-mp="2czx1nc0emsio">
                  {feature}
                </span>
              </div>)}
          </div>

          <div className="rounded-xl md:rounded-2xl px-4 py-3.5 md:px-8 md:py-6 mt-5 md:mt-8 text-center max-w-2xl mx-auto space-y-1.5 md:space-y-2 bg-white/5 border border-white/10" data-id="element-65" data-mp="2mqrux0c2isdm">
            <p className="font-medium text-sm md:text-lg text-gray-200 leading-snug" data-id="element-66" data-mp="2wq8ud00q8a15">
              Abrís la clase, leés 30 segundos y la dictás.
            </p>
            <p className="font-bold text-base md:text-xl text-brandOrange leading-snug" data-id="element-67" data-mp="2qy2bm7wgmaze">
              Sesiones para todo el año, sin perder más tiempo.
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
};
export const Bonuses = () => {
  const bonuses = [{
    num: '01',
    title: '🎁 El Calendario Antiestrés',
    desc: 'Planificación anual lista para copiar y pegar. 12 meses de clases organizadas en una sola mirada.',
    value: '$8.000'
  }, {
    num: '02',
    title: '🎁 Banco de Frases GAP',
    desc: '120 consignas palabra por palabra para controlar el patio. Decís la frase. El grupo arranca. Sin gritar.',
    value: '$9.000'
  }, {
    num: '03',
    title: '🎁 Evaluación Flash Sin Estrés',
    desc: 'Rúbricas y registros en 1 hoja para primaria y secundaria. Sin cortar el juego. Sin llevarte trabajo a casa.',
    value: '$8.000'
  }, {
    num: '04',
    title: '🎁 Kit Día de Lluvia',
    desc: '25 soluciones para no perder la clase cuando no hay patio. Aula, pasillo o SUM: igual tenés clase completa.',
    value: '$9.000'
  }, {
    num: '05',
    title: '🎁 Espacios Chicos',
    desc: '25 actividades para patios mínimos y grupos grandes. Menos espacio no es excusa. Es un desafío resuelto.',
    value: '$8.000'
  }, {
    num: '06',
    title: '🎁 Juegos Rápidos 5 Minutos',
    desc: '30 micro-juegos de emergencia listos para usar. Tenés 5 minutos. Arrancás en 15 segundos.',
    value: '$9.000'
  }];
  return <Section className="bg-[#070f1e] text-white !pt-2 md:!pt-4" data-id="element-68" data-mp="nqthy6vcmagr">
      <FadeIn className="text-center mb-4 md:mb-10" data-id="element-69" data-mp="sol92yo65sjw">
        <h2 className="text-2xl md:text-5xl font-bold text-brandOrange mb-2 md:mb-4 flex items-center justify-center gap-2 md:gap-4" data-id="element-70" data-mp="wpevtopvl1b7">
          + 6 BONOS ESTRATÉGICOS
        </h2>
        <p className="text-sm md:text-xl font-medium text-gray-300" data-id="element-71" data-mp="2uhszp498fwl3">
          Incluidos en todas las ofertas — sin costo extra
        </p>
      </FadeIn>

      <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6 mb-8 md:mb-12" data-id="element-72" data-mp="5ncmthgd5ktc">
        {bonuses.map((bono, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-73" data-mp="pt9qkveje2z" data-mpi={i}>
            <div className="bg-white/10 rounded-xl md:rounded-2xl p-3 md:p-6 border border-white/20 h-full relative overflow-hidden group hover:bg-white/15 transition-colors flex flex-col" data-id="element-74" data-mp="eo13kjx55z9x">
              <div className="absolute -right-3 -top-3 md:-right-4 md:-top-4 text-4xl md:text-6xl font-black text-white/5 group-hover:text-white/10 transition-colors" data-id="element-75" data-mp="okdvpdd1g52k">
                {bono.num}
              </div>
              <div className="text-brandOrange font-bold mb-1 md:mb-2 text-[10px] md:text-base" data-id="element-76" data-mp="yapajuy9fyo8">
                BONO {bono.num}
              </div>
              <h3 className="text-sm md:text-xl font-bold mb-1.5 md:mb-3 leading-tight" data-id="element-77" data-mp="17bnhom3zwmb1">
                {bono.title}
              </h3>
              <p className="text-gray-300 mb-3 md:mb-6 text-[11px] md:text-sm leading-snug" data-id="element-78" data-mp="12dvhl4t75tvr">
                {bono.desc}
              </p>
              <div className="mt-auto pt-2 md:pt-4 border-t border-white/10 flex items-center justify-between gap-2" data-id="element-79" data-mp="1lwj9r6ft8b8d">
                <span className="text-gray-400 line-through text-[10px] md:text-sm" data-id="element-80" data-mp="1cxxov4mv8k4f">
                  {bono.value}
                </span>
                <span className="bg-green-500 text-white text-[9px] md:text-xs font-bold px-2 md:px-3 py-0.5 md:py-1 rounded-full" data-id="element-81" data-mp="1gyhkg3rsjfog">
                  GRATIS
                </span>
              </div>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} className="text-center bg-white/5 py-4 px-4 md:py-8 md:px-6 rounded-xl md:rounded-2xl border border-white/10 max-w-2xl mx-auto mb-6 md:mb-10" data-id="element-82" data-mp="t9yi04vf9x4a">
        <p className="text-sm md:text-xl text-gray-300 mb-1 md:mb-2" data-id="element-83" data-mp="k9a0v1aqfgn6">
          Valor total de los 6 Bonos
        </p>
        <p className="text-xl md:text-5xl font-black text-gray-500 line-through mb-1 md:mb-3" data-id="element-84" data-mp="p8v07cttdr0f">
          $51.000
        </p>
        <p className="text-lg md:text-4xl font-bold mb-1 text-[#22C55E]" data-id="element-85" data-mp="h6m1bh3hmw4v">
          🎁 GRATIS — Solo con tu MegaPack
        </p>
        <p className="text-[11px] md:text-sm text-gray-400" data-id="element-86" data-mp="c9cco3nxaoi3">
          Incluidos en las ofertas. Siempre.
        </p>
      </FadeIn>
    </Section>;
};
export const UrgencyCounter = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section className="bg-[#060f1c] px-4 md:px-8 py-6 md:py-10 overflow-hidden" data-id="element-87" data-mp="3umtrfif2jpm2">
      <div className="max-w-6xl mx-auto" data-id="element-88" data-mp="3pnqj9p3sl39v">
        <FadeIn className="max-w-lg mx-auto" data-id="element-89" data-mp="3pmp5vdzb04oz">
          <div className="relative rounded-2xl md:rounded-3xl border-2 border-brandOrange bg-[#070f1e] p-5 md:p-8 text-center space-y-5 md:space-y-6 animate-counter-glow" data-id="element-90" data-mp="3koe1hirs2me5">
            <h3 className="text-xs md:text-base font-bold text-brandOrange uppercase tracking-[0.15em] flex items-center justify-center gap-2 leading-tight" data-id="element-91" data-mp="3govemhgec18o">
              <span data-id="element-92" data-mp="1ewgzfq58lavy">⏰</span>
              <span data-id="element-93" data-mp="1evxjug326yl3">PRECIO DE LANZAMIENTO — CIERRA EN:</span>
            </h3>

            <div className="flex justify-center items-center gap-2 md:gap-4 text-white" data-id="element-94" data-mp="2wrzeul827lhc">
              <div className="relative" data-id="element-95" data-mp="31rc75lhp9krb">
                <div className="bg-[#060f1c] border-2 border-brandOrange rounded-2xl p-3 md:p-4 min-w-[72px] md:min-w-[90px] shadow-[0_0_25px_rgba(249,115,22,0.5)]" data-id="element-96" data-mp="31q111f0s80x1">
                  <div className="text-4xl md:text-5xl font-black text-brandOrange leading-none tabular-nums" data-id="element-97" data-mp="3aj5np7x8avgw">
                    {hours.toString().padStart(2, '0')}
                  </div>
                  <div className="text-[10px] md:text-xs text-gray-400 mt-2 uppercase font-bold tracking-[0.2em]" data-id="element-98" data-mp="2iuaxhnd7awh1">
                    hs
                  </div>
                </div>
              </div>
              <div className="text-3xl md:text-4xl font-black text-brandOrange animate-pulse" data-id="element-99" data-mp="2rv0ngafs5smu">
                :
              </div>
              <div className="relative" data-id="element-100" data-mp="24drlo5sziu8">
                <div className="bg-[#060f1c] border-2 border-brandOrange rounded-2xl p-3 md:p-4 min-w-[72px] md:min-w-[90px] shadow-[0_0_25px_rgba(249,115,22,0.5)]" data-id="element-101" data-mp="7379dss4hw07">
                  <div className="text-4xl md:text-5xl font-black text-brandOrange leading-none tabular-nums" data-id="element-102" data-mp="238ptjamfxcem">
                    {minutes.toString().padStart(2, '0')}
                  </div>
                  <div className="text-[10px] md:text-xs text-gray-400 mt-2 uppercase font-bold tracking-[0.2em]" data-id="element-103" data-mp="2d2yijoc9in81">
                    min
                  </div>
                </div>
              </div>
              <div className="text-3xl md:text-4xl font-black text-brandOrange animate-pulse" data-id="element-104" data-mp="1keaq98t3ixkz">
                :
              </div>
              <div className="relative" data-id="element-105" data-mp="1u6oy8jarp0fl">
                <div className="bg-[#060f1c] border-2 border-brandOrange rounded-2xl p-3 md:p-4 min-w-[72px] md:min-w-[90px] shadow-[0_0_25px_rgba(249,115,22,0.5)]" data-id="element-106" data-mp="1u7rl8g4yyiq8">
                  <div className="text-4xl md:text-5xl font-black text-brandOrange leading-none tabular-nums animate-pulse" data-id="element-107" data-mp="11p47xmw7s7zp">
                    {seconds.toString().padStart(2, '0')}
                  </div>
                  <div className="text-[10px] md:text-xs text-gray-400 mt-2 uppercase font-bold tracking-[0.2em]" data-id="element-108" data-mp="38d3hs95nz71p">
                    seg
                  </div>
                </div>
              </div>
            </div>

            <div className="flex items-center justify-center gap-2 text-yellow-400 font-bold text-sm md:text-base" data-id="element-109" data-mp="2zf18z7fova3v">
              <AlertTriangle size={18} className="shrink-0" data-id="element-110" data-mp="33cyykbddfy7s" />
              <span data-id="element-111" data-mp="3r5paikl9yhi2">Después sube $20.000 ARS. No vuelve.</span>
            </div>

            <div className="bg-[#060f1c] p-4 md:p-5 rounded-2xl border border-white/10" data-id="element-112" data-mp="3w48vois1np9d">
              <div className="flex justify-between items-center text-[12px] md:text-sm mb-3 gap-2" data-id="element-113" data-mp="3i47t8yw4s9rs">
                <span className="flex items-center gap-2 text-white font-medium" data-id="element-114" data-mp="3n2soejwj039d">
                  <span className="w-1.5 h-1.5 rounded-full bg-brandOrange animate-pulse shrink-0" data-id="element-115" data-mp="26osnb5ly27kj"></span>
                  Cupos al precio de lanzamiento
                </span>
                <span className="text-brandOrange font-bold shrink-0" data-id="element-116" data-mp="2blstrhmphcc6">
                  Quedan pocos
                </span>
              </div>
              <div className="w-full bg-white/5 rounded-full h-2.5 mb-2 overflow-hidden border border-white/10" data-id="element-117" data-mp="2ybucjux8byce">
                <div className="bg-brandOrange h-full rounded-full shadow-[0_0_12px_rgba(249,115,22,0.7)]" style={{
                width: '71%'
              }} data-id="element-118" data-mp="2tec19xvqp718"></div>
              </div>
              <p className="text-[11px] md:text-xs text-gray-400 text-center" data-id="element-119" data-mp="3m3rd2pv8b3y7">
                71% de los cupos al precio de lanzamiento ya tomados
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const Pricing = () => {
  const [selected, setSelected] = useState<'plus' | 'basic'>('plus');
  const offers = {
    plus: {
      checkoutUrl: 'https://www.centershop.store/cart/47776144556183:1',
      cta: 'SÍ, QUIERO EL ARSENAL + POTENCIADOR →',
      value: 27990,
      contentName: 'MegaPack Arsenal + Potenciador',
      contentId: 'arsenal-potenciador'
    },
    basic: {
      checkoutUrl: 'https://www.centershop.store/cart/47775955288215:1',
      cta: 'SÍ, QUIERO MI ARSENAL AHORA →',
      value: 16990,
      contentName: 'MegaPack El Arsenal del Profe',
      contentId: 'arsenal-basico'
    }
  } as const;
  const current = offers[selected];
  return <Section className="bg-[#060f1c] py-8 md:py-24" id="pricing" data-id="element-120" data-mp="u6lswtqd3jly">
      <FadeIn className="text-center mb-4 md:mb-8" data-id="element-121" data-mp="u49gsx7ac3gt">
        <h2 className="text-2xl md:text-5xl font-black text-white" data-id="element-122" data-mp="z4ncrgvm3myh">
          Elegí tu <span className="text-brandOrange" data-id="element-123" data-mp="13wf8e5tmkivh">ARSENAL:</span>
        </h2>
        <p className="text-gray-400 mt-1 md:mt-3 text-xs md:text-base" data-id="element-124" data-mp="13y8bxc8xymz9">
          Todas las opciones incluyen los 6 bonos estratégicos
        </p>
        <p className="text-brandOrange font-semibold mt-2 md:mt-3 text-sm md:text-base" data-id="element-125" data-mp="1dv4fd3jzgiwy">
          👇 Tu próximo lunes empieza acá
        </p>
        <p className="text-gray-400 mt-1 text-[11px] md:text-sm" data-id="element-126" data-mp="1httzdezj0ypk">
          ⚡ Precio de lanzamiento — por tiempo limitado
        </p>
      </FadeIn>

      <div className="max-w-2xl mx-auto space-y-3 md:space-y-4" data-id="element-127" data-mp="2mabpsf86jy77">
        {/* Option Plus - MÁS ELEGIDO */}
        <FadeIn delay={0.1} data-id="element-128" data-mp="2r954gaz7dv8y">
          <button onClick={() => setSelected('plus')} className={`w-full text-left rounded-2xl p-4 md:p-6 transition-all duration-300 border-2 ${selected === 'plus' ? 'bg-[#0a1320] border-brandOrange' : 'bg-[#0a1320]/40 border-white/10 hover:border-white/25 opacity-70 hover:opacity-90'}`} data-id="element-129" data-mp="2r8wqefrcgjw6">
            <div className="flex items-start gap-3 md:gap-4" data-id="element-130" data-mp="357mre6hab3pt">
              <div className={`w-6 h-6 rounded-full border-2 mt-1 shrink-0 flex items-center justify-center ${selected === 'plus' ? 'border-brandOrange' : 'border-gray-500'}`} data-id="element-131" data-mp="3a17qk1um63ql">
                {selected === 'plus' && <div className="w-3 h-3 rounded-full bg-brandOrange" data-id="element-132" data-mp="3o07c30mty2ij"></div>}
              </div>
              <div className="flex-grow min-w-0" data-id="element-133" data-mp="1cddnbnij9z1p">
                <div className="flex flex-wrap items-center gap-1.5 md:gap-2 mb-1.5" data-id="element-134" data-mp="1cb0u2e7bs29c">
                  <span className="text-lg" data-id="element-135" data-mp="17cpl05outvs6">🏆</span>
                  <h3 className="text-base md:text-xl font-black text-white" data-id="element-136" data-mp="13bxcjent3uwy">
                    MEGA PACK + POTENCIADOR
                  </h3>
                </div>
                <div className="flex flex-wrap gap-1.5 md:gap-2 mb-1.5 md:mb-2" data-id="element-137" data-mp="yfp0wb8tijuj">
                  <span className="bg-brandOrange text-white text-[10px] md:text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-138" data-mp="1v2tng9qb3phl">
                    ⭐ MÁS ELEGIDO
                  </span>
                  <span className="bg-green-600 text-white text-[10px] md:text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-139" data-mp="1ma04a17qo5yg">
                    AHORRÁS $28.000
                  </span>
                </div>
                <p className="text-gray-400 text-xs md:text-sm" data-id="element-140" data-mp="2esdsd939wdkc">
                  6 Tomos Completos + 6 Bonos incluidos + 6 Volúmenes del
                  Potenciador de Clases
                </p>
              </div>
              <div className="text-right shrink-0" data-id="element-141" data-mp="2sxw90nqbies8">
                <p className="text-gray-500 line-through text-xs md:text-sm" data-id="element-142" data-mp="2xwh11zvf1s5l">
                  $49.990
                </p>
                <p className={`text-2xl md:text-4xl font-black ${selected === 'plus' ? 'text-brandOrange' : 'text-white'}`} data-id="element-143" data-mp="2k4167mco50fr">
                  $21.990
                </p>
              </div>
            </div>
          </button>
        </FadeIn>

        {/* Option Basic */}
        <FadeIn delay={0.2} data-id="element-144" data-mp="2f7aqx18ou8ve">
          <button onClick={() => setSelected('basic')} className={`w-full text-left rounded-2xl p-4 md:p-6 transition-all duration-300 border-2 ${selected === 'basic' ? 'bg-[#0a1320] border-brandOrange' : 'bg-[#0a1320]/40 border-white/10 hover:border-white/25 opacity-70 hover:opacity-90'}`} data-id="element-145" data-mp="2f3d5g8yn158c">
            <div className="flex items-start gap-3 md:gap-4" data-id="element-146" data-mp="3gov5s75j2h7">
              <div className={`w-6 h-6 rounded-full border-2 mt-1 shrink-0 flex items-center justify-center ${selected === 'basic' ? 'border-brandOrange' : 'border-gray-500'}`} data-id="element-147" data-mp="3e2mtqcfsixx">
                {selected === 'basic' && <div className="w-3 h-3 rounded-full bg-brandOrange" data-id="element-148" data-mp="1xp2gaahqxgtd"></div>}
              </div>
              <div className="flex-grow min-w-0" data-id="element-149" data-mp="1swivasgqbjej">
                <div className="flex flex-wrap items-center gap-1.5 md:gap-2 mb-1.5" data-id="element-150" data-mp="27lyglsxhqwmu">
                  <span className="text-lg" data-id="element-151" data-mp="27o1dmwx29q12">📘</span>
                  <h3 className="text-base md:text-xl font-black text-white" data-id="element-152" data-mp="22mc2lh9u9ccz">
                    MEGAPACK EL ARSENAL DEL PROFE
                  </h3>
                </div>
                <p className="text-gray-400 text-xs md:text-sm" data-id="element-153" data-mp="2bnabodz4wa2f">
                  6 Tomos Completos + 6 Bonos incluidos
                </p>
              </div>
              <div className="text-right shrink-0" data-id="element-154" data-mp="mayfakcqqset">
                <p className="text-gray-500 line-through text-xs md:text-sm" data-id="element-155" data-mp="hau6zhlzl3zo">
                  $34.990
                </p>
                <p className={`text-2xl md:text-4xl font-black ${selected === 'basic' ? 'text-brandOrange' : 'text-white'}`} data-id="element-156" data-mp="jnwaafgzfx5l">
                  $16.990
                </p>
              </div>
            </div>
          </button>
        </FadeIn>

        {/* Single CTA - updates based on selection */}
        <FadeIn delay={0.3} data-id="element-157" data-mp="gimont1kfs">
          <CTAButton href={current.checkoutUrl} fullWidth onClick={selected === 'basic' ? markBasicCheckoutReturn : undefined} className="text-sm md:text-xl py-3 md:py-5 mt-3 md:mt-6 animate-glow-button" trackEvent={{
          name: 'InitiateCheckout',
          params: {
            value: current.value,
            currency: 'ARS',
            content_name: current.contentName,
            content_ids: [current.contentId],
            content_type: 'product',
            num_items: 1
          }
        }} data-id="element-158" data-mp="182j281htq8">
            {current.cta}
          </CTAButton>
          <div className="flex flex-wrap justify-center gap-2 md:gap-4 mt-2 md:mt-4 text-[10px] md:text-xs text-gray-500 font-medium" data-id="element-159" data-mp="35vu22zd6ki6d">
            <span data-id="element-160" data-mp="30vpopi7kk3kd">🔒 Pago 100% seguro</span>
            <span data-id="element-161" data-mp="30yk77470veb5">⚡ Acceso en 5 minutos</span>
            <span data-id="element-162" data-mp="2vyfrhgdxunlz">🛡️ Garantía 30 días</span>
          </div>
        </FadeIn>
      </div>
    </Section>;
};
export const Potenciador = () => {
  const comparisons = [{
    bad: 'Sacás las pelotas y el grupo se dispersa en 30 segundos',
    good: '20 sesiones técnicas con pelota, conos y pecheras. Todos participan.'
  }, {
    bad: 'Los conos están en el depósito pero no sabés cómo usarlos bien',
    good: 'Circuitos de velocidad y táctica que el grupo pide repetir.'
  }, {
    bad: 'Querés dar clases de preparación física pero no sabés estructurarlas',
    good: '20 sesiones atléticas con sogas, colchonetas y bastones listas.'
  }, {
    bad: 'Tus alumnos de secundaria se aburren o no participan',
    good: 'Inteligencia motriz con aros y tortuguitas: piensan mientras se mueven.'
  }];
  const volumes = [{
    icon: '📕',
    title: 'Volumen 1 — Táctica y Precisión',
    materials: 'Pelotas + Conos + Pecheras',
    desc: '20 sesiones técnicas y tácticas para secundaria'
  }, {
    icon: '📗',
    title: 'Volumen 2 — Rendimiento Atlético',
    materials: 'Sogas + Colchonetas + Bastones',
    desc: '20 sesiones de preparación física real'
  }, {
    icon: '📘',
    title: 'Volumen 3 — Lógica y Destreza',
    materials: 'Aros + Tortuguitas + Materiales Mixtos',
    desc: '20 sesiones de inteligencia motriz avanzada'
  }, {
    icon: '📙',
    title: 'Volumen 4 — Power & Drills',
    materials: 'Bancos + Colchonetas + Conos',
    desc: '20 sesiones de entrenamiento funcional y alta intensidad'
  }, {
    icon: '📔',
    title: 'Volumen 5 — ADN Deportivo',
    materials: 'Fútbol + Básquet + Vóley + Handbol',
    desc: '20 sesiones de táctica específica por deporte'
  }, {
    icon: '📓',
    title: 'Volumen 6 — Hybrid Pro',
    materials: 'Sistema Completo Integrado',
    desc: '20 sesiones donde el físico, la táctica y la mente trabajan juntos'
  }];
  return <Section className="bg-[#070f1e]" data-id="element-163" data-mp="3f502m121xtcf">
      <FadeIn className="text-center max-w-3xl mx-auto mb-16" data-id="element-164" data-mp="2remakajgvuhu">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-165" data-mp="2rf5shr94aivv">
          🕊️ ¿QUÉ AGREGA EL POTENCIADOR DE CLASES?
        </h2>
        <p className="text-lg text-gray-300" data-id="element-166" data-mp="31cscgs59x0mp">
          El Arsenal del Profe resuelve el problema del profe que llega sin nada
          preparado. El Potenciador lleva ese sistema al siguiente nivel:{' '}
          <strong className="text-brandOrange" data-id="element-167" data-mp="gmbcxzcih1ii">
            clases con materiales deportivos que se sienten como un
            entrenamiento de club profesional.
          </strong>
        </p>
      </FadeIn>

      <FadeIn delay={0.2} className="max-w-5xl mx-auto mb-8 md:mb-16" data-id="element-168" data-mp="264rfkku4h7r7">
        <h3 className="text-lg md:text-2xl font-bold text-center text-white mb-4 md:mb-8" data-id="element-169" data-mp="2a5jpzheqdip2">
          ✅ EL POTENCIADOR INCLUYE:
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-2.5 md:gap-6 mb-4 md:mb-8" data-id="element-170" data-mp="2f3lisu1ykwdq">
          {volumes.map((vol, i) => <div key={i} className="bg-[#0c1626] border border-white/10 rounded-xl md:rounded-2xl p-3 md:p-6 shadow-sm hover:border-brandOrange hover:shadow-md transition-all" data-id="element-171" data-mp="2jwo3sdso6xib" data-mpi={i}>
              <div className="text-2xl md:text-4xl mb-2 md:mb-4 leading-none" data-id="element-172" data-mp="2tvdnmc44ms17">
                {vol.icon}
              </div>
              <h4 className="font-bold text-[13px] md:text-lg text-white mb-1 leading-tight" data-id="element-173" data-mp="32uqzfbfq3sp3">
                {vol.title}
              </h4>
              <p className="text-[11px] md:text-sm font-semibold text-brandOrange mb-1.5 md:mb-3 leading-snug" data-id="element-174" data-mp="13io679harjy8">
                {vol.materials}
              </p>
              <p className="text-gray-300 text-[11px] md:text-sm leading-snug" data-id="element-175" data-mp="10x71laujb1us">
                {vol.desc}
              </p>
            </div>)}
        </div>

        <div className="bg-brandOrange/10 border border-brandOrange/20 text-white rounded-xl md:rounded-2xl p-3.5 md:p-6 text-center" data-id="element-176" data-mp="w45ggl3qi62r">
          <p className="text-sm md:text-xl font-bold mb-1 md:mb-2 text-brandOrange leading-snug" data-id="element-177" data-mp="m8k9s9nq0hmo">
            Total: 120 sesiones adicionales de alto nivel
          </p>
          <p className="text-gray-300 text-xs md:text-base leading-snug" data-id="element-178" data-mp="1ewgfu4z6jlw4">
            Para el profe de secundaria que no se conforma con lo básico.
          </p>
        </div>
      </FadeIn>

      <div className="max-w-4xl mx-auto" data-id="element-179" data-mp="19z7w3zydv9sr">
        <div className="bg-[#0c1626] rounded-3xl overflow-hidden border border-white/10 shadow-sm" data-id="element-180" data-mp="15wjkxlm75qsm">
          <div className="grid grid-cols-2 bg-white/5 p-4 font-bold text-center text-sm md:text-base" data-id="element-181" data-mp="3unuhpyeakh2d">
            <div className="text-gray-400" data-id="element-182" data-mp="3qkxutvhpxysm">❌ Sin Potenciador</div>
            <div className="text-green-400" data-id="element-183" data-mp="2pd3rjeevtjsd">✅ Con Potenciador</div>
          </div>
          <div className="divide-y divide-white/5" data-id="element-184" data-mp="2pb0pfw0gg07a">
            {comparisons.map((row, i) => <div key={i} className="grid grid-cols-2 p-4 md:p-6 gap-4 text-sm md:text-base" data-id="element-185" data-mp="2kcfofuddpchs" data-mpi={i}>
                <div className="text-gray-400 pr-4" data-id="element-186" data-mp="2uc6ijuy11phc">{row.bad}</div>
                <div className="text-white font-medium pl-4 border-l border-white/5" data-id="element-187" data-mp="383uu9x4d6bxs">
                  {row.good}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
};